import { AxiosResponse } from 'axios'
import { useQuery } from 'react-query'

//constants
import QueryKeys from 'constants/queryKeys'
//services
import { getPiggyChestConfig } from 'services/piggyBankChestService'
//types
import { PiggyBankChestConfig } from 'types'

const usePiggyBankChestConfig = () => {
  const { data, isLoading } = useQuery<AxiosResponse<PiggyBankChestConfig, Error>>(
    QueryKeys.GET_PIGGY_BANK_CHEST_CONFIG,
    getPiggyChestConfig,
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )
  return { piggyChestConfig: data?.data, isPiggyChestLoading: isLoading }
}

export default usePiggyBankChestConfig
